'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var intervalId = void 0,
    auth = void 0,
    usePopup = void 0,
    authOptions = void 0,
    onError = void 0,
    checkSessionOptions = void 0,
    returnToAfterLogout = void 0;

var initAuthHelpers = exports.initAuthHelpers = function initAuthHelpers(config) {
  auth = config.client;
  usePopup = config.usePopup;
  authOptions = config.authOptions;
  checkSessionOptions = config.checkSessionOptions;
  onError = config.onError || Function.prototype;
  returnToAfterLogout = config.returnToAfterLogout || window.location.origin;

  if (!intervalId) {
    intervalId = setInterval(function () {
      return getAuthToken();
    }, 50 * MINUTE);
  }
};

function handleAuthResult(_ref) {
  var expiresInSeconds = _ref.expiresIn,
      accessToken = _ref.accessToken;

  localStorage.setItem('auth.accessToken', accessToken);

  var expiration = expiresInSeconds * 1000 + Date.now();
  localStorage.setItem('auth.expiration', expiration);
}

var login = exports.login = function login(_ref2) {
  var onCompleted = _ref2.onCompleted,
      withUserInfo = _ref2.withUserInfo;

  function cb(error, authResult) {
    if (error) {
      onError(error);
      return;
    } else {
      handleAuthResult(authResult);
    }

    onCompleted && onCompleted(error, authResult && authResult.accessToken);

    if (withUserInfo) {
      auth.client.userInfo(authResult.accessToken, function (error, user) {
        withUserInfo(error, user);
      });
    }
  }

  if (usePopup) {
    auth.popup.authorize(authOptions, cb);
  } else {
    auth.authorize(authOptions, cb);
  }
};

var logout = exports.logout = function logout() {
  localStorage.removeItem('auth.accessToken');
  auth.logout({ returnTo: returnToAfterLogout });
};

var refreshToken = function refreshToken(doLoginIfTokenExpired) {
  return new Promise(function (resolve, reject) {
    auth.checkSession(checkSessionOptions, function (error, authResult) {
      if (error) {
        if (doLoginIfTokenExpired) {
          login({
            onCompleted: function onCompleted(error, token) {
              if (error) {
                reject(error);
              } else {
                resolve(token);
              }
            }
          });
        } else {
          reject(error);
        }
      } else {
        handleAuthResult(authResult);
        resolve(authResult.accessToken);
      }
    });
  });
};

var MINUTE = 1000 * 60,
    HOUR = MINUTE * 60;

var getAuthToken = exports.getAuthToken = function getAuthToken() {
  var _ref3 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref3$doLoginIfTokenE = _ref3.doLoginIfTokenExpired,
      doLoginIfTokenExpired = _ref3$doLoginIfTokenE === undefined ? false : _ref3$doLoginIfTokenE;

  var token = localStorage.getItem('auth.accessToken'),
      authTokenExists = !!token;

  if (authTokenExists) {
    var expiration = parseInt(localStorage.getItem('auth.expiration'), 10),
        now = Date.now(),
        isExpired = expiration < now - MINUTE,
        // leeway
    willExpireSoon = expiration < now + HOUR;

    if (isExpired) {
      return refreshToken(doLoginIfTokenExpired);
    } else {
      if (willExpireSoon) {
        refreshToken(doLoginIfTokenExpired);
      }

      return token;
    }
  } else {
    // either user has never logged in, or has logged out,
    // in which case we don't want to auto log them back in
    return null;
  }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/auth0-helpers/dist/index.js
// module id = 345
// module chunks = 0